<template>
    <div class="h-100" style="padding-bottom: 14px;">
        <div style="height:55px;border-bottom: 1px solid #1e1e1e;padding:8px 0px;" class="filter-fields-in-logs w-100">
            
            <filters-top-bar 
            v-bind="currentDownloadReportProperties"
            @changeSelectedReportComponent="changeSelectedReportComponent">
            </filters-top-bar>

            <button-top-bar
             v-on:click.native="downloadArchiveReportData()">
            </button-top-bar>
        </div>
        <div class="archive-report-div" style="margin-top: 16px;">
            <table class="table table-with-border table-scroll small-first-col"  style="background: transparent;width:100%;">
                <thead style="color: #eee">
                    <tr>
                        <th style="width: 29%;padding-inline-start: 0px !important;" class="text-left">{{$t('FileName')}}</th>
                        <th style="width: 10%;padding-inline-start: 0px !important;"   class="text-left">{{$t('Username')}}</th>
                        <th style="width: 11%" class="text-center">{{$t('DateTime')}}</th>
                        <th style="width: 11%;" class="text-center">{{$t('Size')}}</th>
                        <th style="width: 10%;" class="text-center">{{$t('Duration')}}</th>
                        <th style="width: 14%;" class="text-center">{{$t('Pool Id')}}</th>
                        <th style="width: 15%;" class="text-center">{{$t('Storage Class')}}</th>
                    </tr>
                </thead>
                <tbody v-if="archiveReportData">
                    <tr
                        v-for="archiveLog in archiveReportData"
                        :key="archiveLog._id"
                        class="ccomm-logs-row" :class="{activeclass: activeIndex === archiveLog._id}">
    
                        <td class="text-left" style="position:relative;padding-inline-end: 10px !important;">
                            <span v-if="Object.keys(archiveLog).includes('resource_name') && archiveLog.resource_name && archiveLog.resource_name.length > 0" class="text-ellipsis" :title="archiveLog.resource_name">{{ archiveLog.resource_name }}</span>
                            <span v-else class="validationmessage">-</span>
                        </td>

                        <td class="text-left" style="position:relative;">
                            <span v-if="Object.keys(archiveLog).includes('user_id') && archiveLog.user_id && archiveLog.user_id.length > 0" class="text-ellipsis" :title="getUserNameFromId(archiveLog.user_id)">{{ getUserNameFromId(archiveLog.user_id) }}</span>
                            <span v-else class="validationmessage">-</span>
                        </td>

                        <td class="text-center">
                            <!-- <span v-if="Object.keys(archiveLog).includes('created_datetime') && archiveLog.created_datetime && archiveLog.created_datetime.length > 0">{{formatedDate(archiveLog.created_datetime)}}</span> -->
                            <span v-if="Object.keys(archiveLog).includes('created_datetime') && archiveLog.created_datetime && archiveLog.created_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(archiveLog.created_datetime)">{{checkIsTodayoryesterdayDate(archiveLog.created_datetime)?getDateAndTimeInConfiguredFormat(archiveLog.created_datetime, true) : getDateAndTimeInConfiguredFormat(archiveLog.created_datetime)}}</span>
                            <span v-else class="validationmessage">-</span>
                        </td>

                        <td class="text-center">
                            <span v-if="Object.keys(archiveLog).includes('data') && archiveLog.data && archiveLog.data.size && archiveLog.data.size != null && archiveLog.data.size != undefined">{{getConvertedFileSize(archiveLog.data.size)}}</span>
                            <span v-else class="validationmessage">-</span>
                        </td>

                        <td class="text-center">
                            <span v-if="Object.keys(archiveLog).includes('data') && archiveLog.data.duration">{{getHumanReadableDuration(archiveLog.data.duration)}}</span>
                            <span v-else> - </span>
                        </td>

                        <td class="text-center">
                            <span v-if="Object.keys(archiveLog).includes('data') && archiveLog.data.pool_id && Object.values(getPoolsfromInMem()).length">{{getPoolsfromInMem()[archiveLog.data.pool_id].pool_name}}</span>
                            <span v-else class="validationmessage">-</span>
                        </td>
                        <td class="text-center">
                            <span v-if="Object.keys(archiveLog).includes('data') && archiveLog.data.storage_class && archiveLog.data.storage_class.length > 0 ">{{archiveLog.data.storage_class}}</span>
                            <span v-else class="validationmessage">-</span>
                        </td>

                    </tr>
                </tbody>
            </table> 
        </div>  
        <div>
            <pagination
                v-model="page"
                :records="totalArchiveFiles"
                :per-page="perPage"
                @paginate="paginate"
                :options="options"
                style="margin-top:10px"
            />    
        </div>         
    </div>
</template> 

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import Utils from "../../components.utils.js";  
    import buttonsTopbar from "./headerbar.vue";
    import Pagination from "vue-pagination-2";
    // import DatePicker from "vue2-datepicker";
    // import "vue2-datepicker/index.css";
    // import Multiselect from 'vue-multiselect';
    import FiltersTopbar from "./filtersBar.vue";
    export default {
        data(){
            return{
                page: 1,
                totalPages: -1,
                totalArchiveFiles: -1,
                perPage: -1,
                archiveReportData:[],
                archiveUserMap:[],
                userNameIdMap:{},
                time1:null,
                selectedUserInfo:{},
                selectedUserGroupInfo:{},
                filterBy:{},
                userListFromAutocomplete:[],
                userGroupListFromAutocomplete:[],
                searchByUser:"",
                showUserFilter:false,
                showUserGroupFilter:false,
                searchByGroup:"",
                fileNameFilter:"",
                // filterByAction:{
                //     state:"All",
                //     job_name:"All"
                // },
                options:{chunk:5},
                selectedJobName:"All",
                searchKey :"",

                payloadParams : {},
                activeIndex:null,
            } 
        },  
        components:{
            // 'k-progress': KProgress,
            pagination: Pagination,
            "button-top-bar":buttonsTopbar,
            "filters-top-bar":FiltersTopbar,
        },
        methods:{
            changeSelectedReportComponent(filtersdata){
                this.payloadParams = filtersdata;
                this.refreshArchiveReport(false);
            },

            refreshArchiveReport(isPageClick = false) {
                // this.showUserFilter = false
                // this.showUserGroupFilter = false
                let payload = {}
                // let paramsInfo = {}
                if(isPageClick){
                     this.payloadParams.page = this.page
                }

                payload.params = this.payloadParams;
                payload.isPrivExists = this.isPrivilegeExists('reports');
                this.getArchvieReportFromServer(payload).then((data) => {
                    this.totalPages = data["page_count"];
                    // this.page = data["page"];
                    this.totalArchiveFiles = data["total_archived_files"];
                    this.perPage = data["archived_files_per_page"];
                    this.archiveReportData = data.archived_files;
                    this.archiveUserMap = data.user_map;
                    this.userListFromAutocomplete = []
                    this.userGroupListFromAutocomplete = []
                }); 
                
            },
            isPrivilegeExists(privilegeName){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(), privilegeName);
            },

            paginate() {
                // this.page = page;
                this.refreshArchiveReport(true);
            },

            downloadArchiveReportData() {
                // let filePath = url;
                let payload = {};
                payload.params =this.payloadParams;
                this.$toast.info("You will be notified once the report is ready to download");
                payload.isPrivExists = this.isPrivilegeExists('reports'); 
                this.downloadArchvieReportFromServer(payload).then(() => {
                    console.log("Downloading report")
                    // let archiveReportList = response.data.archive_jobs
                //     if(this.archiveReportData.length == 0){
                //         this.$toast.warning("Empty Archvie report");
                //         return false;
                //     }
                // const blob = new Blob([response.data], {
                //     type: "application/vnd.csv",
                // });
                // const link = document.createElement("a");
                // link.href = URL.createObjectURL(blob);
                // link.setAttribute(
                //     "download",
                //     response.headers["content-disposition"].split("filename=")[1]
                // );
                // document.body.appendChild(link);        
                // link.click();
                })
                .catch(console.error);
            },

            getUserGroupsOnKeyup(){
                this.showUserGroupFilter = true
                this.showUserFilter = false
                let payload = {};
                payload.params = {user_id: this.selectedUserID};
                this.getAllUserGroupsFromServer(payload).then((data)=>{
                    this.userGroupListFromAutocomplete = data.user_groups;
                });
            },

            getConvertedFileSize(size){
                return Utils.getConvertedFileSize(size);
            }, 
            getHumanReadableDuration(duration){
                return Utils.getDurationInSeconds(duration)
            },
            formatedDate(date){
                return Utils.getDateTimeFormat(date);
            },

            getUserNameFromId(userId){
                let username = ""
                if(this.archiveUserMap && this.archiveUserMap.length > 0){
                    let usermap = this.archiveUserMap.filter((usersMap)=>(usersMap.user_id == userId))
                    if(usermap != undefined &&  typeof usermap != "undefined" && usermap[0]!= undefined){
                      
                        username = usermap[0].username
                    }
                }
                return username
            },
            
            handleArchiveNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message && notification.message.job_name == "Archive"){
                    this.refreshArchiveReport(false)
                }
            },
            registerforWebsocketNotifications(){
                this.addWSEventListener({
                    eventname:["JOB_STATUS_UPDATE"],
                    callback:this.handleArchiveNotification,
                    parent: "ArchiveReports"})
            },
            unRegisterforWebsocketNotifications(){
                this.removeWSEventListener({
                    eventname:["JOB_STATUS_UPDATE"],
                    callback:this.handleArchiveNotification,
                    parent: "ArchiveReports"})
            },
            ...mapActions("archiveReports", ["getArchvieReportFromServer", "downloadArchvieReportFromServer"]),
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserPrivilege"]),
            ...mapGetters("pools",["getPoolsfromInMem"])
        },
        beforeDestroy(){
            this.unRegisterforWebsocketNotifications()
        },
        created(){
            this.searchByUser = this.getLoggedInUser()
            this.selectedUserInfo._id= this.getLoggedInUserId();
            this.showUserFilter = false;
            let loggedInUserIdList = [];
            loggedInUserIdList.push(this.selectedUserInfo._id);
            this.payloadParams["user_id"] = JSON.stringify(loggedInUserIdList);
            this.refreshArchiveReport(false);
            this.registerforWebsocketNotifications()
        },

        computed: {
            currentDownloadReportProperties() {
                return { reportContext : "archive"};
            },
        },
    }
</script>            

<style scoped lang="scss">
    $table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;

/* width */
::-webkit-scrollbar {
    width: 8px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }

    .text-ellipsis{
        white-space: nowrap; 
        width: 88%; 
        overflow: hidden;
        text-overflow: ellipsis; 
        display: block;
        position: absolute;
    }
    .archive-report-div{
        padding: 0px 30px 10px 30px;
        height: calc(100% - 115px);
        overflow: auto;
    }

    .table-scroll thead th {
        position: sticky;
        top: 0;
        background: $primary-background;
        z-index: 9;
    }

    th, td{
        text-align: start;
    }

    tbody tr{
        border-bottom: $secondary-border-color;
    }
    table td, table th{
        vertical-align: top;
    }
    .activeclass {
        color: $active-blue;
    }
    .ccomm-logs-row:hover {
        .jobs-info-icon{
            visibility:visible;
        }
    }

    .ccomm-logs-row:hover{
        color: $active-blue;
    }
    .table-with-border {
        thead {
            border-bottom: none;
        }
        tr {
            border-bottom: none;
        }
    }
    
    .table{
        color:#fff !important;
        th{
            border-top:none !important;
            padding: 1rem !important;
        }
        td{
            border-top:none !important;
            padding: 0px !important;
            padding-inline-start: 2px !important;
        }
    }
    .primary-btn-style{
        width: 100%;
        text-align: end;
        button{
            height: 38px;
            width: 70px;
            font-size:14px;
        }
        .text-light:hover{
        text-decoration: underline;
        }
    }
    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th{
            position: sticky;
            top: 0;
            background:$primary-background;
            z-index:9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr{
                height:60px !important;
                td{
                    span{
                        word-break: break-all;
                    }
                }
            }
        }
    }

    .search-bar-comm-style {
        height: 30px;
        position: relative;
        input {
            border: $border-color !important;
            position: absolute;
            top: 12%;
            inset-inline-start:5%;
            height: 38px !important;
            padding-inline-start: 8%;
        }
        svg {
            position: absolute;
            inset-inline-start:24px;
            top: 34%;
        }
    }

    .value-style {
        color: $text-color;
        width: 97%;
        text-align: start;
        padding-top: 3px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
    }

    .filter-fields-in-logs div{
        display:inline-flex;
        div.comm-div{
            display:inline-flex;
            width:25%;
            // padding-top:7px;
            position: relative;
            // inset-inline-end :2%;
            label{
            color:$dull-text-color;
            position: relative;
            inset-inline-end: 5px;
            width:30%;
            text-align:end;
            top:2px;
            }
            select,input{
            width:70%;
            height:27px;
            border:$border-color !important;
            }
        }
    }

    li {
      width: 25%;
      display: inline-flex;
      // margin-bottom: 20px;
    }

    .config-label {
        width: 26% !important;
        text-align: end;
        color: #757575;
        word-break: break-word;
        position: relative !important;
        top: 9px !important;
    }
    
    .config-value {
        margin-inline-start: 4px;
        width: 75% !important;
        display:grid;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }

    ::v-deep {
         .page-item.disabled .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none;
  }
  .page-item.active .page-link {
    background-color: $secondary-background-color !important;
    // border: none !important;
    border: $border-color !important;
    color: $active-blue;
    z-index: 0 !important;
  }
  .page-link {
    background-color: $secondary-background-color !important;
    border: $border-color !important;
    // border: none !important;
    color: $text-color;
    padding: 5px !important;
  }
  .page-link:hover {
    background-color: $bg-color-on-hover !important;
  }
  .pagination {
    float: inline-end;
    margin-bottom: 0px !important;
    margin-inline-end: 8px;
  }
  .VuePagination__count {
    color: $secondary-text-color !important;
    margin-bottom: 0px !important;
    font-size: 12px;
    margin-inline-end: 7px;
    margin-top: 1px;
    float: inline-end;
    position: relative;
    margin-inline-start: 5px;
    top: 5px;
  }
  .VuePagination__pagination-item {
    font-size: 14px;
    width: 27px;
  }
  .VuePagination__pagination-item-prev-chunk {
    display: none;
  }
  .VuePagination__pagination-item-next-chunk {
    display: none;
  }

  .VuePagination__pagination-item-prev-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page {
    width: 50px !important;
  }

  .VuePagination__pagination-item-next-page a:before {
    width: 50px;
    content: "next ";
  }

  .VuePagination__pagination-item-prev-page a:after {
    width: 50px;
    content: " prev";
  }
  .v-list {
    padding: 0px !important;
  }
  .v-list-item {
    text-align: start;
    border: $secondary-border-color !important;
    min-height: 37px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    .v-list-item__title {
      font-size: 14px !important;
      color: $text-color !important;
    }
  }
  .v-menu__content {
    width: 190px !important;
  }
}    

</style>